import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14c59aa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-gallery p-grid p-col-12 p-nogutter" }
const _hoisted_2 = { class: "current p-col-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Profile image", -1))
const _hoisted_4 = { class: "available p-col-7" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "select synced image", -1))
const _hoisted_6 = { class: "available-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "add p-mt-6"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4 upload" }, " UPLOAD FROM GALLERY", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EntityPhoto = _resolveComponent("EntityPhoto")!
  const _component_entity_photo = _resolveComponent("entity-photo")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_EntityPhoto, {
        url: _ctx.selectedPhoto,
        class: "current-photo",
        type: _ctx.type
      }, null, 8, ["url", "type"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePhotos, (photo) => {
          return (_openBlock(), _createElementBlock("div", {
            key: photo,
            class: _normalizeClass(["available-list-item", {
            'selected': _ctx.selectedPhoto === photo,
            [_ctx.type]: true,
          }]),
            onClick: ($event: any) => (_ctx.selectPhoto(photo))
          }, [
            _createVNode(_component_entity_photo, {
              type: _ctx.type,
              url: photo
            }, null, 8, ["type", "url"])
          ], 10, _hoisted_7))
        }), 128)),
        (_ctx.allowAdd)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["available-list-item", { [_ctx.type]: true }])
            }, [
              _createVNode(_component_entity_photo, {
                type: _ctx.type,
                action: "add",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddInput = true))
              }, null, 8, ["type"])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (_ctx.allowAdd)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.selectedPhoto.custom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    label: "Remove",
                    class: "p-button-text p-button-secondary gi-button p-text-uppercase",
                    icon: "pi pi-times",
                    onClick: _ctx.removeCustomPhoto
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAddInput)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_InputText, {
                    class: "tittle-input w-50",
                    type: "text",
                    modelValue: _ctx.customURL,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customURL) = $event)),
                    placeholder: "Paste photo url here",
                    onKeydown: _withKeys(_ctx.addCustomPhoto, ["enter"])
                  }, null, 8, ["modelValue", "onKeydown"]),
                  _createVNode(_component_Button, {
                    label: "Add",
                    class: "p-button-text p-button-secondary gi-button p-text-uppercase p-ml-3",
                    icon: "pi pi-plus-circle",
                    onClick: _ctx.addCustomPhoto
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    label: "Cancel",
                    class: "p-button-text p-button-secondary gi-button p-text-uppercase",
                    icon: "pi pi-times",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddInput = false))
                  }),
                  _createElementVNode("label", null, [
                    _createElementVNode("input", {
                      type: "file",
                      name: "photo",
                      accept: "image/*",
                      ref: "uploadPhotoInput",
                      id: "Image",
                      style: {"visibility":"hidden","display":"none"},
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleFileUpload()))
                    }, null, 544),
                    _hoisted_11
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}